import { render } from "./PricesPage.vue?vue&type=template&id=659dd3ce&scoped=true"
import script from "./PricesPage.vue?vue&type=script&lang=js"
export * from "./PricesPage.vue?vue&type=script&lang=js"

import "./PricesPage.vue?vue&type=style&index=0&id=659dd3ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-659dd3ce"]])

export default __exports__